import React, { useEffect, useState,useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { DownOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Col,
  Flex,
  Form,
  message,
  Row,
  Select,
  Space,
} from "antd";
import {
  CustomInput,
  CustomSelect,
  CustomButton,
  CustomDynamicSelect,
  CustomTitle,
  AddItemButton,
  CustomParagraph,
} from "../../components";
import deleteRedIcon from "../../assets/images/delete-red.svg";
import { useToken } from "../../common/helper";
import { useSpin } from "../../components/SpinContext";
import { AddUsers, GetUserById } from "../../api's/onboarding";
import { getTeamsDDL } from "../../common/utils/dropDown";

import {
  AssignPermissionOptions,
  PermissionOptions,
} from "../../common/static_data";
import PhoneInput from "react-phone-input-2";
import deleteIcon from "../../assets/images/delete.svg";
import { Option } from "antd/es/mentions";
import { PlusOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { GetRoles } from "../../api's/roles";
import TeamsSelector from "../../components/TeamsSelector";
import TeamSelectField from "../../components/TeamSelectField";
import { getTeamsDDLOFFeature } from "../../common/utils/dropDown";
import { isValidPhoneNumber } from "libphonenumber-js";

const SettingsInviteUserForm = ({
  form,
  id,
  handleCloseDrawer,
  handleFetchAllUsers,
  fetchPendingInvitesUsers,
}) => {
  const { token, removeToken, getUserID } = useToken();
  const [teamRoleHistory, setTeamRoleHistory] = useState({});

  const navigate = useNavigate();
  const isSameUser = Number(id) === Number(getUserID());
  const { showSpin, hideSpin } = useSpin();
  const [isEdit, setIsEdit] = useState(id ? true : false);
  //   const { id } = useParams();
  const [permissionOptions, setPermissionOptions] = useState(
    AssignPermissionOptions
  );
  const [isFormValid, setIsFormValid] = useState(false);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const { decodedUserToken } = useToken();
  let decodedToken = decodedUserToken();
  let isCompanyOwner = decodedToken?.is_company_owner === true;
  const rolePriority = {
    Admin: 3,
    Member: 2,
    Viewer: 1,
  };
  const teamRoleHistoryRef = useRef({});

  //teams for drop down
  const teamsList = useSelector((state) => state.teams.list);
  
    const hasValidTeams = !(
      teamsList.length === 0 ||
      (teamsList.length === 1 && teamsList[0].name.toLowerCase() === "default")
    );

  const [allTeams, setAllTeams] = useState([]);
  
  useEffect(() => {
    getTeamsDDLOFFeature(token, "Users").then((val) => {
      if (val && val.length > 0) {
        setAllTeams(val);
      }
    });
  }, []);

  //get user by Id
  useEffect(() => {
    if (id) {
      fetchUserById(id);
    }
  }, [id]);

  const fetchUserById = (id) => {
    showSpin();
    GetUserById(token, id)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let resp = data?.data?.data ? data?.data?.data : null;
            if (resp) {
              const formattedTeams = Array.isArray(resp.teams)
                ? resp.teams.map((item) => {
                    const teamObj =
                      typeof item.team === "string" && allTeams.length > 0
                        ? allTeams.find((t) => t.id === item.team)
                        : item;
                        const roleId = item.role;
                        const roleName = roleList.find((r) => r.id === roleId)?.name;
                        if (teamObj?.id && roleName) {
                          teamRoleHistoryRef.current[teamObj.id] = roleName; // store roleName
                        }
                    return {
                      team: teamObj,
                      role: item.role,
                    };
                  })
                : [];
                const teams = form.getFieldValue("teams") || [];

const mappedRoles = {};
formattedTeams.forEach((item) => {
  const teamId = item?.team?.id;
  const roleId = item?.role;
  const roleName = item?.team?.role_name; // from your object

  if (teamId && roleId && roleName) {
    mappedRoles[teamId] = { roleId, roleName };
  }
});

setTeamRoleHistory(mappedRoles);


console.log('role',{mappedRoles})
console.log('teams',formattedTeams)
              form.setFieldsValue({
                name: resp.name || "",
                id: resp.id || null,
                email: resp.email || "",
                role: resp.role || "",
                title: resp.title || "",
                phone_number: resp.phone_number || "",
                teams: formattedTeams,
              });
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const onFinish = (values) => {
    if (values && Object.keys(values).length > 0) {
      const formattedTeams = values.teams?.map((item) => ({
        team: Array.isArray(item.team)
          ? item.team[0]?.id
          : item.team?.id || item.team,
        role: item.role,
      }));

      const model = {
        ...values,
        teams: formattedTeams,
        id: id && id !== "" ? id : null,
      };

      handleSendInviteUser(model);
    }
  };

  const handleSendInviteUser = (model) => {
    setIsFormValid(true);
    showSpin();
    AddUsers(token, model, false)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
            message.success(data?.data?.message);
            form.resetFields();
            handleFetchAllUsers(false);
            fetchPendingInvitesUsers();
            handleCloseDrawer();
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
        setIsFormValid(false);
      });
  };

  // default values are set on drawer open
  useEffect(() => {
    form.setFieldsValue({
      teams: [{ team: undefined, role: undefined }],
    });
  }, [form]);

  const handleDisableRole = (data) => {
    const updatedRoleList = roleList.map((item) => {
      // Disable "admin" role only if data has length 1 and includes a "default" item
      const shouldDisableAdmin =
        data?.length === 1 &&
        data.some((x) => x.name.toLowerCase() === "default");

      // Set "admin" role to disabled if the condition is met, otherwise enable it
      return {
        ...item,
        disabled:
          item.name.toLowerCase() === "admin" ? shouldDisableAdmin : false,
      };
    });

    setRoleList(updatedRoleList);
  };

  // const teamsArr = [
  //   { id: 1, value: "hr", label: "Human Resources", color: "#FF5733" },
  //   { id: 2, value: "it", label: "Information Technology", color: "#33B5FF" },
  //   { id: 3, value: "finance", label: "Finance", color: "#33FF57" },
  //   { id: 4, value: "marketing", label: "Marketing", color: "#FF33A8" },
  //   { id: 5, value: "sales", label: "Sales", color: "#FFC300" },
  //   { id: 6, value: "operations", label: "Operations", color: "#8D33FF" },
  // ];

  const [roleList, setRoleList] = useState([]);

  const fetchAllRoles = () => {
    showSpin();
    GetRoles(token)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let arr = data?.data?.data.length > 0 ? data?.data?.data : [];
            if (arr.length > 0) {
              setRoleList(arr);
              // setFeatureName(createFeatureNameList(arr))
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  useEffect(() => {
    fetchAllRoles();
  }, []);

  return (
    <>
      <Form
        form={form}
        name="userSettingsForm"
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
        className="drawer-children-h flex flex-col justify-between"
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <div
          style={{
            position: "absolute",
            top: "40px",
            paddingTop: "0px",
            left: "0",
            padding: "0px 32px",
            width: "100%",
            background: "#fff",
            zIndex: "2",
          }}
        >
          <CustomTitle
            text={id ? "Edit user" : "Invite user"}
            fontSize={20}
            fontWeight="700"
            lineHeight="32px"
            color="#000"
            marginBottom={0}
          />
        </div>

        <div
          style={{
            flex: 1,
            // overflowY: "auto",
            paddingBottom: "130px",
            paddingTop: "16px",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
          className="custom-scrollbar"
        >
          <Row gutter={[16, 16]}>
            {/* name  */}
            <Col span={24}>
              <Form.Item
                className="custom-input form-input-style"
                label="Name"
                name="name"
                rules={[
                  { required: true, message: "Please enter name" },
                  {
                    type: "string",
                    min: 3,
                    message: "Name must be at least 3 characters long",
                  },
                ]}
                style={{ marginBottom: "0px" }}
              >
                <CustomInput
                  placeholder="Enter name"
                  height="36px"
                  width={"100%"}
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
            </Col>
            {/* title */}
            <Col span={24}>
              <Form.Item
                className="custom-input form-input-style"
                label="Title"
                name="title"
                rules={[
                  { required: true, message: "Please enter title" },
                  {
                    type: "string",
                    min: 2,
                    message: "Title must be at least 2 characters long",
                  },
                ]}
                style={{ marginBottom: "0px" }}
              >
                <CustomInput
                  placeholder="Enter title"
                  height="36px"
                  width={"100%"}
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
            </Col>
            {/* email  */}
            <Col span={24}>
              <Form.Item
                className="custom-input form-input-style"
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please enter your email" },
                  { type: "email", message: "Enter valid email" },
                ]}
                style={{ marginBottom: "0px" }}
              >
                <CustomInput
                  placeholder="Enter email"
                  height="36px"
                  width={"100%"}
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
            </Col>
            {/* phone_number */}
            <Col span={24}>
              <Form.Item
                className="custom-input form-input-style"
                label={"Phone number (optional)"}
                name="phone_number"
                style={{ marginBottom: "0px" }}
                initialValue=""
                // rules={[
                //   {
                //     validator: (_, value) => {
                //       if (!value || value.trim() === "") {
                //         return Promise.resolve();  
                //       }
                //       const digitsOnly = value.replace(/\D/g, "");
                
                //       if (digitsOnly.length >= 10) {
                //         return Promise.resolve();
                //       }
                
                //       return Promise.reject(new Error("Please enter a valid phone number"));
                //     },
                //   },
                // ]}

                 rules={[
                                  {
                                    validator: (_, value) => {
                                      if (!value || value.trim() === '') {
                                        return Promise.resolve(); // Optional
                                      }
                                      try {
                                        if (isValidPhoneNumber(value)) {
                                          return Promise.resolve();
                                        } else {
                                          return Promise.reject(new Error("Invalid phone number"));
                                        }
                                      } catch {
                                        return Promise.reject(new Error("Invalid phone number"));
                                      }
                                    },
                                  },
                                ]}
                
                
              >
                <PhoneInput
                  country={"us"}
                  value={form.getFieldValue("phone_number")}
                  onChange={(value, countryData, e, formattedValue) => {
                    form.setFieldsValue({ phone_number: formattedValue });
                  }}
                />
              </Form.Item>
            </Col>

            {/* teams + role  */}

            <>
              <Form.List name="teams">
                {(fields, { add, remove }) => (
                  <>
                    <Col span={24}>
                      <div style={{ fontWeight: "600", marginBottom: "0px" }}>
                      {hasValidTeams ? 'Team + role' : 'Role' }  
                      </div>
                    </Col>

                    <Col span={24}>
                      <Row gutter={[8, 8]}>
                        {fields.map(({ key, name, ...restField }, index) => {
                          const selectedTeamIds = form
                            .getFieldValue("teams")
                            ?.map((field, i) => i !== index && field?.team?.id)
                            ?.filter(Boolean);

                          const teamValue = form.getFieldValue([
                            "teams",
                            name,
                            "team",
                          ]);

                          const roleValue = form.getFieldValue([
                            "teams",
                            name,
                            "role",
                          ]);

                          console.log(`Field ${index} - Team:`, teamValue);
                          console.log(`Field ${index} - Role:`, roleValue);
                          const isAlreadySelected = selectedTeamIds?.includes(
                            teamValue?.id
                          );

                          const isDisabled =
                            (teamValue?.name?.toLowerCase() === "default" &&
                              isCompanyOwner &&
                              id &&
                              teamValue?.role_name?.toLowerCase() ===
                                "admin") ||
                            isAlreadySelected;

                          return (
                            <React.Fragment key={key}>
                           
                           {hasValidTeams &&
                              <Col
                                span={11}
                                style={{
                                  pointerEvents: isDisabled ? "none" : "auto",
                                  cursor: isDisabled
                                    ? "not-allowed"
                                    : "pointer",
                                  opacity: isDisabled ? 1 : 1,
                                }}
                              >
                                <Form.Item
                                  {...restField}
                                  name={[name, "team"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Select a team",
                                    },
                                  ]}
                                  style={{
                                    width: "100%",
                                    backgroundColor: isDisabled
                                      ? "#fff"
                                      : "#f3f3f3",
                                    border: `1px solid ${
                                      isDisabled ? "#e8e8e8" : "tranparent"
                                    }`,
                                    fontSize: "12px",
                                    borderRadius: "8px",
                                    pointerEvents: isDisabled ? "none" : "auto",
                                  }}
                                >
                                  <TeamSelectField
                                    name={name}
                                    allTeams={allTeams}
                                    isEdit={isEdit}
                                    onTeamChange={handleDisableRole}
                                    selectedTeamIds={selectedTeamIds}
                                  />

                                  {/* <TeamSelectField
                                    name={name}
                                    allTeams={allTeams}
                                    isEdit={isEdit}
                                    onTeamChange={handleDisableRole}
                                  /> */}
                                </Form.Item>
                              </Col>
                        }
                              <Col
                                span={hasValidTeams ? 11 : 22}
                                style={{
                                  pointerEvents: isDisabled ? "none" : "auto",
                                  //opacity: isDisabled ? 1 : 1,
                                }}
                              >
                                <Form.Item
                                  {...restField}
                                  name={[name, "role"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Select a role",
                                    },
                                  ]}
                                  style={{
                                    width: "100%",
                                    backgroundColor: isDisabled
                                      ? "#fff"
                                      : "#f3f3f3",
                                    border: `1px solid ${
                                      isDisabled ? "#e8e8e8" : "tranparent"
                                    }`,
                                    fontSize: "12px",
                                    borderRadius: "8px",
                                    pointerEvents: isDisabled ? "none" : "auto",
                                  }}
                                >
                                  <CustomDynamicSelect
                                    className="form-input-style"
                                    placeholder="Select"
                                    disabled={false}
                                    width={"100%"}
                                    height="36px"
                                    border="0px"
                                    bgColor="#F3F3F3"
                                    textColor="#5E5E5E"
                                    borderRadius="8px"
                                    options={roleList.map((role) => {
                                      const selectedTeam = form.getFieldValue(["teams", name, "team"]);
                                      const previouslyAssigned = teamRoleHistory?.[selectedTeam?.id];
                                    
                                      const selectedRoleId = form.getFieldValue(["teams", name, "role"]);
                                      const selectedRoleName = roleList.find((r) => r.id === selectedRoleId)?.name;
                                    
                                      const shouldDisable =
                                        isEdit &&
                                        isSameUser &&
                                        previouslyAssigned &&
                                        rolePriority[role.name] > rolePriority[previouslyAssigned.roleName];
                                    
                                      return {
                                        ...role,
                                        label: role.name,
                                        value: role.id,
                                        disabled: shouldDisable,
                                      };
                                    })}
                                    
                                    // options={roleList.map((role) => {
                                    //   const selectedRole = form.getFieldValue([
                                    //     "teams",
                                    //     name,
                                    //     "role",
                                    //   ]);
                                    //   const selectedRoleName = roleList.find(
                                    //     (r) => r.id === selectedRole
                                    //   )?.name;

                                    //   const shouldDisable =
                                    //     isEdit &&
                                    //     isSameUser &&
                                    //     rolePriority[role.name] >
                                    //       rolePriority[selectedRoleName];

                                    //   return {
                                    //     ...role,
                                    //     label: role.name,
                                    //     value: role.id,
                                    //     disabled: shouldDisable,
                                    //   };
                                    // })}
                                  />

                                  {/* <CustomDynamicSelect
                                    className="form-input-style"
                                    placeholder="Select"
                                   // onChange={handleDisableRole([teamValue])}
                                    disabled={false}
                                    width={'100%'}
                                    height="36px"
                                    border="0px"
                                    bgColor="#F3F3F3"
                                    textColor="#5E5E5E"
                                    borderRadius="8px"
                                    options={roleList}
                                  /> */}
                                </Form.Item>
                              </Col>

                              <Col
                                span={2}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {fields.length > 0 && (
                                  <img
                                    src={deleteIcon}
                                    alt=""
                                    onClick={() => {
                                      if (index === 0 && isDisabled) {
                                        message.error(
                                          "You don't have right to delete admin"
                                        );
                                      } else {
                                        remove(index);
                                      }
                                    }}
                                  />
                                )}
                              </Col>
                            </React.Fragment>
                          );
                        })}
                      </Row>
                    </Col>
                    <Col span={24}>
                      <AddItemButton
                        marginTop="0px"
                        fontSize="12px"
                        fontWeight="600"
                        text={` ${id ? "Assign" : "Add"} ${hasValidTeams ?'team + role' : 'role' }  `}
                        onClick={() => {
                          add();
                        }}
                      />
                    </Col>
                  </>
                )}
              </Form.List>
              <Col span={24}>
                <p className="invite-user-text">
                  Teams control what content and data a user sees. Roles control
                  what a user can do. Learn more about roles{" "}
                  <span>
                    {" "}
                    <Link to="/settings/roles"> here</Link>
                  </span>
                  .
                </p>
              </Col>
            </>

            {/* <Col span={24}>
                <Form.Item
                className="custom-input"
                label="Permission"
                name="role"
                rules={[{ required: true, message: "Select permission" }]}
                style={{ marginBottom: "0px" }}
                >
                <CustomSelect
                    placeholder="Select"
                    onChange={(value) => console.log("value")}
                    width={"100%"}
                    height="36px"
                    border="0px"
                    bgColor="#F3F3F3"
                    textColor="#5E5E5E"
                    borderRadius="8px"
                    options={permissionOptions}
                />
                </Form.Item>
            </Col> */}
          </Row>

          {/* form bottom buttons  */}
          <div
            style={{
              background: "#fff",
              position: "absolute",
              bottom: "0",
              left: "0",
              width: "100%",
              padding: "0 24px 24px",
            }}
          >
            <Row gutter={[0, 8]} style={{ marginTop: "0px" }}>
              <CustomButton
                text={id ? "Save" : "Invite"}
                width={"100%"}
                height={48}
                borderRadius={8}
                bgColor={isFormValid ? "#F3F3F3" : "#000"}
                color={isFormValid ? "#A6A6A6" : "#fff"}
                border="0px"
                fontSize={16}
                fontWeight={600}
                htmlType="submit"
                isFormValid={isFormValid}
              />
              <CustomButton
                key="button1"
                width={"100%"}
                onClick={() => handleCloseDrawer()}
                text={"Cancel"}
                bgColor="transparent"
                color="black"
                fontSize="16px"
                fontWeight="600"
                boxShadow="none"
                height="48px"
              />
            </Row>
          </div>
        </div>
      </Form>
    </>
  );
};

export default SettingsInviteUserForm;
